<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="quickSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="filter.searchDate"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Currency</label>
                  <a-select
                    placeholder="Currency"
                    v-model="filter.currency"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getAllMataUang"
                      :key="item.code"
                    >
                      {{ item.currency }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>Status</label>
                  <a-select
                    placeholder="Status"
                    v-model="filter.status"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option value="Active"> Active </a-select-option>
                    <a-select-option value="Non Active">
                      Non Active
                    </a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Bank Account List"
        createLink="bank-account-create"
        :dataList="datasource"
        :swapaction="true"
      >
        <template slot="swapaction" slot-scope="data">
          <a-button icon="edit" @click="handleEdit(data.item.id)">Edit</a-button>
        </template>
      </DataList>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "bank-account-list",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: false,
      rawData: [],
      filter: {
        searchDate: null,
        status: null,
        currency: null,
      },
      quickSearch: "",
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.keyword &&
            obj.keyword.toLowerCase().indexOf(this.quickSearch.toLowerCase()) >=
              0
        );
      }

      if (this.filter.searchDate) {
        let filter = moment(this.filter.searchDate).format(
          this.getDefaultDateFormat
        );
        outputData = _.filter(
          outputData,
          (obj) =>
            moment(obj.create_dt).format(this.getDefaultDateFormat) == filter
        );
      }

      if (this.filter.currency) {
        outputData = _.filter(
          outputData,
          (obj) => obj.currency == this.filter.currency
        );
      }

      if (this.filter.status) {
        outputData = _.filter(
          outputData,
          (obj) => obj.status_besar == this.filter.status
        );
      }

      return outputData;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      this.$store.dispatch("FETCH_ALL_MATA_UANG");
      this.$store
        .dispatch("FetchBankDB", { auth: this.getAuth })
        .then((res) => {
          res.forEach((data) => {
            this.rawData.push({
              id: data.bank_account_id,
              status_besar: data.active == "1" ? "Active" : "Non Active",
              title: data.nama_bank + " - " + data.bank_account_id,
              create_dt: data.create_dt,
              currency: data.currency,
              keyword:
                data.address +
                " " +
                data.create_dt +
                " " +
                data.bank_account_id +
                " " +
                data.currency +
                " " +
                data.kode_rekening +
                " " +
                data.nama_bank +
                " " +
                data.pemilik +
                " " +
                data.swift_code,
              subtitle: data.kode_rekening + " (" + data.currency + ")",
              subdesc: [
                [
                  {
                    label: "Address : ",
                    value: data.address,
                  },
                  {
                    label: "Swift code : ",
                    value: data.swift_code,
                  },
                ],
                data.pemilik,
                data.create_dt,
              ],
            });
          });
        });
    },
    handleEdit(item) {
      this.$router.push({
        name: "bank-account-edit",
        params: { id: item }
      });
    },
  },
};
</script>

<style></style>
